/* eslint-disable no-else-return */

import { withStyles } from '@material-ui/core/styles'
import { Help } from '@material-ui/icons'
import cn from 'classnames'
import React from 'react'

import StatusLabel from '../StatusLabel'
import Tooltip from '../Tooltip'

const styles = theme => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    width: '100%',
    '&.withDivider': {
      paddingBottom: '12px',
      marginBottom: '12px',
      borderBottom: theme.borders.default,
    },
  },
  label: {
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: theme.typography.fontSizeSm,
    color: `var(--gameday-body-textColorAlt, ${theme.body.textColorAlt})`,
  },
  icon: {
    marginLeft: '8px',
    fontSize: '16px',
  },
})

const ContrastText = () => (
  <React.Fragment>
    <p>Colour Contrast refers to how bright or dark colours appear between the text and the text background.</p>
    <p>Website accessibility is a concern for colourblind and other visually impaired users.</p>
    <p>As per WCAG Guidelines your contrast checker should Pass before proceeding.</p>
  </React.Fragment>
)

const ColorChecker = ({ classes, helpText, label, result, withDivider }) => {
  const scoreResult = myScore => {
    if (myScore === 'Fail') {
      return <StatusLabel label="Fail" variant="error" />
    } else if (myScore === 'AA Large') {
      return <StatusLabel label="Warning" variant="warning" />
    }
    return <StatusLabel label="Pass" variant="success" />
  }

  return (
    <div className={cn(classes.root, { withDivider })}>
      {label && (
        <span className={classes.label}>
          {label}
          <Tooltip content={helpText} placement="top">
            <Help className={classes.icon} />
          </Tooltip>
        </span>
      )}
      {scoreResult(result)}
    </div>
  )
}

ColorChecker.defaultProps = {
  helpText: <ContrastText />,
  label: 'Contrast Checker',
  result: '',
}

const ColorCheckerComponent = withStyles(styles)(ColorChecker)
ColorCheckerComponent.displayName = 'ColorChecker'
export default ColorCheckerComponent
